export class SystemConfigurations {
    FromEmail: any
    FromEmailPwd: any
    Host: any
    Port: any

}

